import { Page } from "@/models/page-models/Page";

export const UpdatePaymentCollection: Page = {
  "path": "update-payment-collection",
  "name": "Update Payment Collection",
  "props": {
    "data": {
      "title": "Update Payment Collection",
      "printable": "FALSE",
      "url": "update-payment-collection",
      "groups": [
        {
          "groupItems": [
            {
              "name": "2a",
              "pageItems": [
                {
                  "type": "custom_InvoicePaymentDetails",
                  "variable": "formData",
                  "label": "Invoice Payment Details",
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{formData.status}},'),!==,'Pending'),&&,fn(LOGICAL,fn(MATCH_ROLE,Accounting | Manager),||,fn(MATCH_ROLE,Accounting | Executive)))"
                }
              ]
            },
            {
              "name": "2b",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "fetchedData.selectedCustomerId",
                  "label": "Select Customer",
                  "onVarUpdate": [
                    {
                      "executionOrder": 1,
                      "name": "copyCustomerContacts"
                    }
                  ],
                  "disabled": "FALSE",
                  "items": "fetchedData.customers.data",
                  "itemText": "name",
                  "itemValue": "_id",
                  "formula": "fn(HELPER_FN,customerAlias,{{__item}})"
                },
                {
                  "type": "dropdown",
                  "variable": "fetchedData.selectedContact",
                  "label": "Select Contact",
                  "onChange": [
                    {
                      "executionOrder": 1,
                      "name": "copyContactDetails"
                    }
                  ],
                  "disabled": "FALSE",
                  "items": "fetchedData.contact",
                  "itemText": "firstName",
                  "itemValue": "firstName",
                  "formula": "fn(HELPER_FN,contactName,{{__item}})"
                }
              ],
              "showIf": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{formData.status}},'),==,'Pending'),||,fn(NOT,fn(LOGICAL,fn(MATCH_ROLE,Accounting | Manager),||,fn(MATCH_ROLE,Accounting | Executive))))"
            },
            {
              "name": "3b",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.customerPaymentMode",
                  "label": "Select Payment Mode",
                  "disabled": "FALSE",
                  "items": "[\"Check\",\"Cash\",\"Transfer\"]",
                  "dropdownType": "static"
                },
                {
                  "type": "input",
                  "variable": "formData.voucherNo",
                  "label": "Foxpro Voucher No",
                  "disabled": "FALSE"
                }
              ],
              "showIf": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{formData.status}},'),==,'Pending'),||,fn(NOT,fn(LOGICAL,fn(MATCH_ROLE,Accounting | Manager),||,fn(MATCH_ROLE,Accounting | Executive))))"
            },
            {
              "name": "3ab",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.bankName",
                  "label": "Select Bank",
                  "disabled": "FALSE",
                  "items": "[{\"text\":\"Arab National Bank: SA69 3040 0108 0953 4466 0011\",\"value\":\"ANB\"},{\"text\":\"Saudi National Bank: SA58 1000 0065 9123 8300 0110\",\"value\":\"SNB\"},{\"text\":\"Banque Saudi Fransi: SA56 5500 0000 0909 8470 0491\",\"value\":\"BSF\"}]",
                  "itemText": "text",
                  "itemValue": "value",
                  "dropdownType": "static"
                },
                {
                  "type": "input",
                  "variable": "formData.bankTransactionNumber",
                  "label": "Bank Transaction No",
                  "disabled": "FALSE"
                }
              ],
              "showIf": "fn(LOGICAL,fn(LOGICAL,{{formData._id}},>,0)"
            },
            {
              "name": "4b",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.expectedAmountReceived",
                  "label": "Amount",
                  "unit": "SAR",
                  "disabled": "FALSE"
                },
                {
                  "type": "fileupload",
                  "variable": "formData.uploadedProof",
                  "label": "Payment Proof",
                  "disabled": "FALSE",
                  "color": "secondary",
                  "previewType": "no-preview"
                }
              ],
              "showIf": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{formData.status}},'),==,'Pending'),||,fn(NOT,fn(LOGICAL,fn(MATCH_ROLE,Accounting | Manager),||,fn(MATCH_ROLE,Accounting | Executive))))"
            },
            {
              "name": "3a",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.voucherNo",
                  "label": "Foxpro Voucher No",
                  "disabled": "FALSE"
                },
                {
                  "type": "fileupload",
                  "variable": "formData.uploadedProof",
                  "label": "Payment Proof",
                  "disabled": "FALSE",
                  "color": "secondary",
                  "previewType": "no-preview"
                }
              ],
              "showIf": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{formData.status}},'),!==,'Pending'),&&,fn(LOGICAL,fn(MATCH_ROLE,Accounting | Manager),||,fn(MATCH_ROLE,Accounting | Executive)))"
            },
            {
              "name": "6",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Invoice Payment Breakdown",
                  "showIf": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{formData.status}},'),!==,'Pending'),&&,fn(LOGICAL,fn(MATCH_ROLE,Accounting | Manager),||,fn(MATCH_ROLE,Accounting | Executive)))",
                  "labelType": "formula",
                  "formula": "fn(CONCAT,Balance: ,fn(HELPER_FN,currency,fn(SUBTRACT,{{formData.expectedAmountReceived}},fn(ARRAY_SUM,{{__item.value}},{{formData.payments}}))))"
                }
              ]
            }
          ],
          "showIf": "fn(LOGICAL,fn(LOGICAL,{{formData._id}},>,0)",
          "type": "genericGroup"
        },
        {
          "type": "arrayGroup",
          "variable": "formData.payments",
          "disabled": "FALSE",
          "showIf": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.selectedCustomer.customerType}},'),!=,'Miscellaneous'),&&,fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{formData.status}},'),!==,'Pending'),&&,fn(LOGICAL,fn(MATCH_ROLE,Accounting | Manager),||,fn(MATCH_ROLE,Accounting | Executive))))",
          "arrayItems": [
            {
              "name": "1a",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "type",
                  "label": "Type",
                  "disabled": "FALSE",
                  "items": "fetchedData.filteredPaymentTypes",
                  "itemText": "name",
                  "itemValue": "name"
                },
                {
                  "type": "dropdown",
                  "variable": "invoice",
                  "label": "Select Invoice",
                  "disabled": "FALSE",
                  "items": "fetchedData.filteredInvoices",
                  "itemText": "_id",
                  "itemValue": "_id",
                  "formula": "fn(HELPER_FN,invoiceDescription,{{__item}})",
                  "dropdownType": "search",
                  "searchFunctions": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copyInvoiceSearchId",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg1Value": "__selectedObject",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.invoiceSearch.q._id"
                      },
                      "name": "copyInvoiceSearchId",
                      "executeIf": "fn(LOGICAL,{{fetchedData.initialInvoiceCount}},>,{{fetchedData.invoiceSearch.limit}})"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "searchApprovedInvoicesByCustomer",
                        "type": "fnGetData",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/invoice/search",
                        "arg2Key": "storeInVar",
                        "arg2Value": "fetchedData.allInvoices",
                        "arg3Key": "postData",
                        "arg3Value": "fetchedData.invoiceSearch"
                      },
                      "name": "searchApprovedInvoicesByCustomer",
                      "executeIf": "fn(LOGICAL,{{fetchedData.initialInvoiceCount}},>,{{fetchedData.invoiceSearch.limit}})"
                    },
                    {
                      "executionOrder": 3,
                      "name": "copyFilteredInvoices",
                      "executeIf": "fn(LOGICAL,{{fetchedData.initialInvoiceCount}},>,{{fetchedData.invoiceSearch.limit}})"
                    }
                  ],
                  "onChange": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "pushSelectedInvoice",
                        "type": "fnPushToArray",
                        "arg1Key": "sourceVariable",
                        "arg1Value": "__selectedObject",
                        "arg2Key": "destinationVariable",
                        "arg2Value": "fetchedData.selectedInvoices"
                      },
                      "name": "pushSelectedInvoice"
                    },
                    {
                      "executionOrder": 2,
                      "name": "copyFilteredInvoices"
                    }
                  ]
                },
                {
                  "type": "input",
                  "variable": "value",
                  "label": "Value",
                  "unit": "SAR",
                  "disabled": "FALSE"
                }
              ],
              "showIf": "fn(LOGICAL,fn(NOT,{{__arrayGroup1._id}}),&&,fn(LOGICAL,fn(CONCAT,',{{__arrayGroup1.type}},'),!=,'Received Advance'))"
            },
            {
              "name": "1a",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "type",
                  "label": "Type",
                  "disabled": "FALSE",
                  "items": "fetchedData.filteredPaymentTypes",
                  "itemText": "name",
                  "itemValue": "name"
                },
                {
                  "type": "dropdown",
                  "variable": "proformaInvoice",
                  "label": "Select Proforma Invoice(QT)",
                  "disabled": "FALSE",
                  "items": "fetchedData.successfulQts.data.docs",
                  "itemText": "_id",
                  "itemValue": "_id",
                  "formula": "fn(HELPER_FN,qtDescription,{{__item}})",
                  "showIf": "fn(NOT,fn(FEATURE_FLAG,advance-payment-without-quotation))"
                },
                {
                  "type": "input",
                  "variable": "value",
                  "label": "Value",
                  "unit": "SAR",
                  "disabled": "FALSE"
                }
              ],
              "showIf": "fn(LOGICAL,fn(NOT,{{__arrayGroup1._id}}),&&,fn(LOGICAL,fn(CONCAT,',{{__arrayGroup1.type}},'),==,'Received Advance'))"
            },
            {
              "name": "2a",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "type",
                  "label": "Type",
                  "disabled": "TRUE",
                  "items": "fetchedData.filteredPaymentTypes",
                  "itemText": "name",
                  "itemValue": "name"
                },
                {
                  "type": "label",
                  "variable": "invoice",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,invoiceDescription,{{__arrayGroup1.invoice}})"
                },
                {
                  "type": "input",
                  "variable": "value",
                  "label": "Value",
                  "unit": "SAR",
                  "disabled": "TRUE"
                }
              ],
              "showIf": "fn(LOGICAL,fn(LOGICAL,{{__arrayGroup1._id}},>,0),&&,fn(LOGICAL,fn(CONCAT,',{{__arrayGroup1.type}},'),!=,'Received Advance'))"
            },
            {
              "name": "2b",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "type",
                  "label": "Type",
                  "disabled": "TRUE",
                  "items": "fetchedData.filteredPaymentTypes",
                  "itemText": "name",
                  "itemValue": "name"
                },
                {
                  "type": "label",
                  "variable": "proformaInvoice",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,qtDescription,{{__arrayGroup1.proformaInvoice}})",
                  "showIf": "fn(NOT,fn(FEATURE_FLAG,advance-payment-without-quotation))"
                },
                {
                  "type": "input",
                  "variable": "value",
                  "label": "Value",
                  "unit": "SAR",
                  "disabled": "TRUE"
                }
              ],
              "showIf": "fn(LOGICAL,fn(LOGICAL,{{__arrayGroup1._id}},>,0),&&,fn(LOGICAL,fn(CONCAT,',{{__arrayGroup1.type}},'),==,'Received Advance'))"
            }
          ],
          "initialArrayLength": 0
        },
        {
          "type": "arrayGroup",
          "variable": "formData.payments",
          "disabled": "FALSE",
          "showIf": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.selectedCustomer.customerType}},'),==,'Miscellaneous'),&&,fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{formData.status}},'),!==,'Pending'),&&,fn(LOGICAL,fn(MATCH_ROLE,Accounting | Manager),||,fn(MATCH_ROLE,Accounting | Executive))))",
          "arrayItems": [
            {
              "name": "1a",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "type",
                  "label": "Type",
                  "disabled": "TRUE",
                  "items": "fetchedData.filteredPaymentTypes",
                  "itemText": "name",
                  "itemValue": "name"
                },
                {
                  "type": "label",
                  "variable": "miscInvoice",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,miscInvoiceDescription,{{__arrayGroup1.miscInvoice}},{{fetchedData.selectedCustomer}})"
                },
                {
                  "type": "input",
                  "variable": "value",
                  "label": "Value",
                  "unit": "SAR",
                  "disabled": "TRUE"
                }
              ],
              "showIf": "fn(LOGICAL,{{__arrayGroup1._id}},>,0)"
            },
            {
              "name": "1b",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "type",
                  "label": "Type",
                  "disabled": "FALSE",
                  "items": "fetchedData.filteredPaymentTypes",
                  "itemText": "name",
                  "itemValue": "name"
                },
                {
                  "type": "dropdown",
                  "variable": "miscInvoice",
                  "label": "Select Invoice",
                  "disabled": "FALSE",
                  "items": "fetchedData.filteredMiscInvoices",
                  "itemText": "_id",
                  "itemValue": "_id",
                  "formula": "fn(HELPER_FN,miscInvoiceDescription,{{__item}},{{fetchedData.selectedCustomer}})"
                },
                {
                  "type": "input",
                  "variable": "value",
                  "label": "Value",
                  "unit": "SAR",
                  "disabled": "FALSE"
                }
              ],
              "showIf": "fn(NOT,{{__arrayGroup1._id}})"
            }
          ],
          "initialArrayLength": 0
        },
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Update Payment",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "name": "updatePaymentCollection"
                    }
                  ],
                  "disabled": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{formData.status}},'),==,'Submitted'),&&,fn(LOGICAL,{{formData.expectedAmountReceived}},!==,fn(ARRAY_SUM,{{__item.value}},{{formData.payments}})))",
                  "color": "primary"
                }
              ],
              "showIf": "fn(LOGICAL,fn(MATCH_ROLE,Accounting | Manager),||,fn(MATCH_ROLE,Accounting | Executive))"
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Update Payment",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "name": "updatePaymentCollection"
                    }
                  ],
                  "disabled": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{formData.status}},'),==,'Approved'),||,fn(LOGICAL,fn(CONCAT,',{{formData.status}},'),==,'Rejected'))",
                  "color": "primary"
                },
                {
                  "type": "button",
                  "label": "Validate Payment",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "validateIpr",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/invoice-payment-receipt/{{formData._id}}/submit",
                        "arg2Key": "postData",
                        "arg2Value": "{}",
                        "arg3Key": "refreshPage",
                        "arg3Value": "TRUE"
                      },
                      "name": "validateIpr"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(CONCAT,',{{formData.status}},'),==,'Pending')",
                  "color": "secondary"
                }
              ],
              "showIf": "fn(NOT,fn(LOGICAL,fn(MATCH_ROLE,Accounting | Manager),||,fn(MATCH_ROLE,Accounting | Executive)))"
            }
          ],
          "type": "genericGroup"
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "name": "getPaymentTypes",
        "executeIf": "fn(LOGICAL,fn(MATCH_ROLE,Accounting | Manager),||,fn(MATCH_ROLE,Accounting | Executive))"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getCustomers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/customers?showDisabled=true",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customers"
        },
        "name": "getCustomers",
        "executeIf": "fn(MATCH_ROLE,Sales | Manager)"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getMyCustomers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/my-customers?showDisabled=true",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customers"
        },
        "name": "getMyCustomers",
        "executeIf": "fn(MATCH_ROLE,Sales | Account Executive)"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getAllCustomers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/customers?showMisc=true&showDisabled=true",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customers"
        },
        "name": "getAllCustomers",
        "executeIf": "fn(NOT,fn(MATCH_DEPARTMENT,SALES))"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getPaymentReceiptDetails",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/invoice-payment-receipt/{{__query.receipt}}",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.receiptDetails"
        },
        "name": "getPaymentReceiptDetails"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "resetInvoiceSearchFilters",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultInvoiceSearchFilters",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.invoiceSearch",
          "arg3Key": "destinationKeyType",
          "arg3Value": "Object",
          "arg4Key": "append",
          "arg4Value": "TRUE"
        },
        "name": "resetInvoiceSearchFilters",
        "executeIf": "fn(LOGICAL,fn(LOGICAL,fn(MATCH_ROLE,Accounting | Manager),||,fn(MATCH_ROLE,Accounting | Executive)),&&,fn(LOGICAL,fn(CONCAT,',{{fetchedData.selectedCustomer.customerType}},'),!=,'Miscellaneous'))"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "pushCustomerId",
          "type": "fnPushToArray",
          "arg1Key": "sourceVariable",
          "arg1Value": "fetchedData.receiptDetails.data.customer._id",
          "arg2Key": "destinationVariable",
          "arg2Value": "fetchedData.invoiceSearch.q.customer"
        },
        "name": "pushCustomerId",
        "executeIf": "fn(LOGICAL,fn(LOGICAL,fn(MATCH_ROLE,Accounting | Manager),||,fn(MATCH_ROLE,Accounting | Executive)),&&,fn(LOGICAL,fn(CONCAT,',{{fetchedData.selectedCustomer.customerType}},'),!=,'Miscellaneous'))"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "copyPaymentData",
          "type": "fnCopyData",
          "arg1Key": "sourceKey",
          "arg1Value": "fetchedData.receiptDetails.data",
          "arg2Key": "destinationKey",
          "arg2Value": "formData",
          "arg3Key": "append",
          "arg3Value": "TRUE",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copyPaymentData"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "copySelectedCustomerId",
          "type": "fnCopyData",
          "arg1Key": "sourceKey",
          "arg1Value": "fetchedData.receiptDetails.data.customer._id",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.selectedCustomerId"
        },
        "name": "copySelectedCustomerId"
      },
      {
        "executionOrder": 2,
        "name": "copySelectedContact"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "copySelectedCustomer",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "findSelectedCustomer",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.selectedCustomer"
        },
        "name": "copySelectedCustomer"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "getApprovedInvoicesByCustomer",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/invoice/search",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.allInvoices",
          "arg3Key": "postData",
          "arg3Value": "fetchedData.invoiceSearch"
        },
        "name": "getApprovedInvoicesByCustomer",
        "executeIf": "fn(LOGICAL,fn(LOGICAL,fn(MATCH_ROLE,Accounting | Manager),||,fn(MATCH_ROLE,Accounting | Executive)),&&,fn(LOGICAL,fn(CONCAT,',{{fetchedData.selectedCustomer.customerType}},'),!=,'Miscellaneous'))"
      },
      {
        "executionOrder": 4,
        "name": "copyFilteredInvoices",
        "executeIf": "fn(LOGICAL,fn(LOGICAL,fn(MATCH_ROLE,Accounting | Manager),||,fn(MATCH_ROLE,Accounting | Executive)),&&,fn(LOGICAL,fn(CONCAT,',{{fetchedData.selectedCustomer.customerType}},'),!=,'Miscellaneous'))"
      },
      {
        "executionOrder": 4,
        "pageFunction": {
          "name": "copyInitialInvoicesTotalCount",
          "type": "fnCopyData",
          "arg1Key": "sourceKey",
          "arg1Value": "fetchedData.allInvoices.data.totalDocs",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.initialInvoiceCount"
        },
        "name": "copyInitialInvoices",
        "executeIf": "fn(LOGICAL,fn(LOGICAL,fn(MATCH_ROLE,Accounting | Manager),||,fn(MATCH_ROLE,Accounting | Executive)),&&,fn(LOGICAL,fn(CONCAT,',{{fetchedData.selectedCustomer.customerType}},'),!=,'Miscellaneous'))"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "getMiscellaneousInvoices",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/misc-invoice/all",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.miscInvoices"
        },
        "name": "getMiscellaneousInvoices",
        "executeIf": "fn(LOGICAL,fn(NOT,fn(MATCH_DEPARTMENT,SALES)),&&,fn(LOGICAL,fn(CONCAT,',{{fetchedData.selectedCustomer.customerType}},'),==,'Miscellaneous'))"
      },
      {
        "executionOrder": 4,
        "pageFunction": {
          "name": "getFilteredMiscInvoices",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "filterMiscInvoices",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.filteredMiscInvoices"
        },
        "name": "getFilteredMiscInvoices",
        "executeIf": "fn(LOGICAL,fn(NOT,fn(MATCH_DEPARTMENT,SALES)),&&,fn(LOGICAL,fn(CONCAT,',{{fetchedData.selectedCustomer.customerType}},'),==,'Miscellaneous'))"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "resetQtSearchFilters",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultQtSearchFilters",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.qtSearch",
          "arg3Key": "destinationKeyType",
          "arg3Value": "Object",
          "arg4Key": "append",
          "arg4Value": "TRUE"
        },
        "name": "resetQtSearchFilters"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "pushCustomerIdToQtSearchForm",
          "type": "fnPushToArray",
          "arg1Key": "sourceVariable",
          "arg1Value": "fetchedData.receiptDetails.data.customer._id",
          "arg2Key": "destinationVariable",
          "arg2Value": "fetchedData.qtSearch.q.customer"
        },
        "name": "pushCustomerIdToQtSearchForm"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "getSuccessfulQtsByCustomer",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/quotation/search",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.successfulQts",
          "arg3Key": "postData",
          "arg3Value": "fetchedData.qtSearch"
        },
        "name": "getSuccessfulQtsByCustomer",
        "executeIf": "fn(LOGICAL,fn(LOGICAL,fn(MATCH_ROLE,Accounting | Manager),||,fn(MATCH_ROLE,Accounting | Executive)),&&,fn(LOGICAL,fn(CONCAT,',{{fetchedData.selectedCustomer.customerType}},'),!=,'Miscellaneous'))"
      }
    ],
    "functions": [
      {
        "name": "getPaymentTypes",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/staticdata?type=invoice-payment-types",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.paymentTypes",
        "arg3Key": "fnsAfterSubmit",
        "arg3Value": "getFilteredPaymentTypes"
      },
      {
        "name": "filterPaymentTypes",
        "type": "fnFilterArray",
        "arg1Key": "sourceVariable",
        "arg1Value": "fetchedData.paymentTypes.data.0.data",
        "arg2Key": "formulaCondition",
        "arg2Value": "fn(CONDITIONAL,fn(LOGICAL,fn(MATCH_ROLE,Accounting | Manager),||,fn(MATCH_ROLE,Accounting | Executive)), true, {{__item.enableForSales}})"
      },
      {
        "name": "getFilteredPaymentTypes",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "filterPaymentTypes",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.filteredPaymentTypes"
      },
      {
        "name": "copyCustomerContacts",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "__selectedObject.contactDetails",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.contact"
      },
      {
        "name": "copyContactDetails",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "__selectedObject",
        "arg2Key": "destinationKey",
        "arg2Value": "formData.contact"
      },
      {
        "name": "updatePaymentCollection",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/invoice-payment-receipt/{{formData._id}}",
        "arg2Key": "postData",
        "arg2Value": "formData",
        "arg3Key": "requestMethod",
        "arg3Value": "PUT",
        "arg4Key": "fnsAfterSubmit",
        "arg4Value": "openPaymentsPage"
      },
      {
        "name": "copySelectedContact",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "fetchedData.receiptDetails.data.contact.name",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.selectedContact"
      },
      {
        "name": "openPaymentsPage",
        "type": "fnRedirect",
        "arg1Key": "redirectUrl",
        "arg1Value": "fn(CONDITIONAL,fn(LOGICAL,fn(MATCH_ROLE,Accounting | Manager),||,fn(MATCH_ROLE,Accounting | Executive)),/accounts-dashboard?tab=1,/sales-dashboard?tab=3)"
      },
      {
        "name": "getDefaultInvoiceSearchFilters",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 20,
          "q": {
            "_id": "",
            "status": "Approved",
            "customer": []
          }
        },
        "staticObject": true
      },
      {
        "name": "findSelectedCustomer",
        "type": "fnFindInArray",
        "arg1Key": "sourceVariable",
        "arg1Value": "fetchedData.customers.data",
        "arg2Key": "searchKey",
        "arg2Value": "_id",
        "arg3Key": "searchValue",
        "arg3Value": "fetchedData.receiptDetails.data.customer._id"
      },
      {
        "name": "filterMiscInvoices",
        "type": "fnFilterArray",
        "arg1Key": "sourceVariable",
        "arg1Value": "fetchedData.miscInvoices.data.docs",
        "arg2Key": "formulaCondition",
        "arg2Value": "fn(LOGICAL,{{__item.customer.id._id}},==,{{fetchedData.selectedCustomerId}})"
      },
      {
        "name": "copyFilteredInvoices",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "getFilteredInvoices",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData",
        "arg3Key": "destinationKeyType",
        "arg3Value": "Object",
        "arg4Key": "append",
        "arg4Value": "TRUE"
      },
      {
        "name": "getFilteredInvoices",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "filteredInvoices": "fn(HELPER_FN,mergeArray,{{fetchedData.allInvoices.data.docs}},{{fetchedData.selectedInvoices}},_id)"
        },
        "useFormula": true
      },
      {
        "name": "getDefaultQtSearchFilters",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 20,
          "q": {
            "status": ["QT Successful"],
            "customer": []
          }
        },
        "staticObject": true
      }
    ]
  },
  "forRole": "ACCOUNTING_MANAGER,ACCOUNTING_EXECUTIVE,SALES_ACCOUNT_EXECUTIVE,SALES_MANAGER,GENERAL_MANAGER",
  "visible": false,
  "routerPriority": 75
}